import { Component } from '@angular/core';

@Component({
  selector: 'app-add-mfa',
  standalone: true,
  imports: [],
  templateUrl: './add-mfa.component.html',
  styleUrl: './add-mfa.component.css'
})
export class AddMfaComponent {

}
